import React from "react";
import { GetStaticPropsContext } from "next";
import MetaTags from "@components/shared/metaTags";
import { useQuery } from "@tanstack/react-query";
import { GQLDomains } from "@gql/types/gql";
import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import initialCall from "@helpers/initial-call";
import MainContent from "@components/whatWeDo/mainContent";
import { ICustomDomain, TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
const WhatWeDo = () => {
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <>
            <MetaTags
                title={translate(
                    translations,
                    "several_aboutUsPage_meta_title", //same meta title as about us page
                )}
                description={translate(
                    translations,
                    "several_aboutUsPage_meta_description", //same meta description as about us page
                )}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
            />
            <section className="max-w-7xl mx-auto px-5">
                <MainContent />
            </section>
        </>
    );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("WhatWeDo", ctx);
};

export default WhatWeDo;
